<template>
  <v-footer height="auto" app fixed class="mt-3">
    <v-spacer></v-spacer>
    <span class="text-xl-right mr-2">
      <router-link to="/infos/datenschutz">Datenschutz</router-link>
      <v-icon small>keyboard_arrow_right</v-icon>
      <router-link to="/infos/nutzungsbedingungen">Nutzungsbedingungen</router-link>
      <template v-if="authenticated">
        <v-icon small>keyboard_arrow_right</v-icon>
        <router-link to="/infos/agb">Allgemeine Geschäftsbedingungen</router-link>
      </template>
      <v-icon small>keyboard_arrow_right</v-icon>
      <router-link to="/impressum">Impressum</router-link>
    </span>
    <PwaEvent></PwaEvent>
  </v-footer>
</template>

<script>

import { mapGetters } from 'vuex'
import PwaEvent from '~/components/PwaEvent.vue'

export default {
  components: {
    PwaEvent
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    }),
    jahr: function () {
      return new Date().getFullYear()
    }
  }
}
</script>
